import axios from "axios";
import Game from "./Types/Game";
import GameRule from "./Types/GameRule";

//@ts-ignore
export const apiUrl = process.env.PUBLIC_URL;

export const logVisitor = async () => {
  await axios.post(`${apiUrl}/logVisitor`);
};

export const createGame = async () => {
  await axios.post(`${apiUrl}/createGame`);
};

export const startGame = async (game: Game) => {
  await axios.post(`${apiUrl}/startGame`, {
    id: game.id,
  });
};

export const spectateGame = async (game: Game, socketId: string) => {
  await axios.post(`${apiUrl}/spectateGame`, {
    id: game.id,
  });
};

export const setGameRules = async (game: Game, rules: GameRule) => {
  await axios.post(`${apiUrl}/setGameRules`, {
    id: game.id,
    rules: rules,
  });
};

export const setTimeLimit = async (game: Game, isTimeLimitEnabled: boolean) => {
  await axios.post(`${apiUrl}/setTimeLimit`, {
    id: game.id,
    isTimeLimitEnabled: isTimeLimitEnabled,
  });
};

export const joinGame = async (
  game: Game,
  name: string,
  isSpectating: boolean
) => {
  await axios.post(`${apiUrl}/joinGame`, {
    id: game.id,
    name: name,
    isSpectating: isSpectating,
  });
};

export const leaveGame = async (game: Game, name: string) => {
  await axios.post(`${apiUrl}/leaveGame`, {
    id: game.id,
    name: name,
  });
};

export const claimTurn = async (game: Game, name: string) => {
  await axios.post(`${apiUrl}/claimTurn`, {
    id: game.id,
    name: name,
  });
};

export const playCard = async (
  game: Game,
  name: string,
  pileIndex: number,
  card: number
) => {
  await axios.post(`${apiUrl}/playCard`, {
    id: game.id,
    name,
    card,
    pileIndex,
  });
};

export const showInterestInPile = async (
  game: Game,
  name: string,
  pileIndex: number
) => {
  await axios.post(`${apiUrl}/showInterestInPile`, {
    id: game.id,
    name,
    pileIndex,
  });
};

export const endTurn = async (game: Game, isDrawOnlyOneCard: boolean) => {
  await axios.post(`${apiUrl}/endTurn`, {
    id: game.id,
    isDrawOnlyOneCard,
  });
};

export const endGame = async (game: Game) => {
  await axios.post(`${apiUrl}/endGame`, {
    id: game.id,
  });
};

export const lostGame = async (game: Game) => {
  await axios.post(`${apiUrl}/lostGame`, {
    id: game.id,
  });
};
